import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const githubPartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('github:view:link:clicked', (payload) =>
    ampli.partnerIntegrationsGithubViewLinkClicked(payload),
  );

  partnerEvents.on('github:link:issue:clicked', (payload) =>
    ampli.partnerIntegrationsGithubLinkIssueClicked(payload),
  );

  partnerEvents.on('github:create:issue:clicked', (payload) =>
    ampli.partnerIntegrationsGithubCreateNewIssueClicked(payload),
  );

  partnerEvents.on('github:create:issue:confirmed', (payload) =>
    ampli.partnerIntegrationsGithubCreateNewIssueConfirmed(payload),
  );

  partnerEvents.on('github:create:issue:canceled', (payload) =>
    ampli.partnerIntegrationsGithubCreateNewIssueCanceled(payload),
  );

  partnerEvents.on('github:unlink:all:clicked', (payload) =>
    ampli.partnerIntegrationsGithubUnlinkAllIssuesClicked(payload),
  );

  partnerEvents.on('github:unlink:all:confirmed', (payload) =>
    ampli.partnerIntegrationsGithubUnlinkAllIssuesConfirmed(payload),
  );

  partnerEvents.on('github:unlink:all:canceled', (payload) =>
    ampli.partnerIntegrationsGithubUnlinkAllIssuesCanceled(payload),
  );

  partnerEvents.on('github:unlink:issue:clicked', (payload) =>
    ampli.partnerIntegrationsGithubUnlinkIssueClicked(payload),
  );

  partnerEvents.on('github:unlink:issue:confirmed', (payload) =>
    ampli.partnerIntegrationsGithubUnlinkIssueConfirmed(payload),
  );

  partnerEvents.on('github:unlink:issue:canceled', (payload) =>
    ampli.partnerIntegrationsGithubUnlinkIssueCanceled(payload),
  );
};
